const MetricCategory = Object.freeze({
  OVERVIEW: 'Overview',
  CONVERGED_MEDIA: 'ConvergedMedia',
  CHANNELS: 'Channels',
  STAR_RATINGS: 'StarRatings',
  SURVEY_SCORES: 'SurveyScores'
})
export default MetricCategory
export type MetricCategoryStrings = typeof MetricCategory[keyof typeof MetricCategory]
// RESERVE BELOW
